<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/a4fCqn/images/cover.jpg?1734367787367" alt="This image is the cover for the book Northern Borders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Northern Borders
      </h1>
      <p class="bookDescription body article font2">
        <b>A New York Times Notable Book: A novel about growing up in a remote corner of Vermont, from the author Richard Russo calls “one of our very best writers.”</b><br/>  <br/> When six-year-old Austen Kittredge was sent up north to live on his grandparents’ farm in 1948, he didn’t know that he would spend the next twelve years of his life there—or that his remarkable stay would never leave him, no matter how far he traveled.<br/>  <br/> The farm in Lost Nation Hollow would become a magical place for Austen, full of eccentric people—like his stubborn but loving grandparents, whose marriage was known as the Forty Years War—wild adventures, and festering family secrets. An enchanting, startling coming-of-age novel, <i>Northern Borders</i> evokes a world of county fairs, heirloom quilts, and timber forests, in “a touching and unforgettable portrait of a people and time that are past” (Fannie Flagg, <i>The New York Times Book Review</i>).<br/>  <br/> “A contemporary classic . . . A complex, yet idyllic, story of childhood in Vermont.” —<i>Los Angeles Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Howard  Frank Mosher
      </h2>
      
      <p class="authorDescription body article">Howard Frank Mosher is the author of ten books, including <I>Waiting for Teddy Williams</I>, <I>The True Account</I>, and <I>A Stranger in the Kingdom</I>, which, along with <I>Disappearances</I>, was corecipient of the New England Book Award for fiction. He lives in Vermont.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7dc9c2a6